export default __webpack_public_path__ + "static/we-believe-orange-icons-with-circle-4fc4cab0b3ff71398859874f45791b0f.svg";